function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M42 4.69A5.36 5.36 0 0038.19.92C34.84 0 21.42 0 21.42 0S8 0 4.66.88A5.51 5.51 0 00.88 4.69C0 8.05 0 15 0 15s0 7 .88 10.31a5.37 5.37 0 003.78 3.77c3.39.92 16.76.92 16.76.92s13.42 0 16.77-.88A5.37 5.37 0 0042 25.34c.89-3.35.89-10.3.89-10.3S42.88 8.05 42 4.69zM17.15 21.42V8.58L28.31 15z",
  fill: "#fb0007"
});

function SvgYoutube(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 42.85 30"
  }, props), _ref);
}

export default __webpack_public_path__ + "assets/images/youtube.68844e2d.svg";
export { SvgYoutube as ReactComponent };